angular.module('core')
    .directive('topAlerts', function() {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: '/resources/core/partials/top-alerts.html',
            controller: 'TopAlertsController'
        };
    });

angular.module('core').controller('TopAlertsController', ['$scope', '$rootScope', 'dblAnalyticsProvider', 'authentication', 'ERROR_CODES', function($scope, $rootScope, $analytics, $authentication, ERROR_CODES) {

    $scope.alerts = [];

    /**
     *
     * @param type  String: "success" | "info" | "warning" | "danger"
     * @param reason  String: "request-rejection" | "edit-mode-blocked"
     * @param data  Object: Any data expected in the template, depending on the <b>reason</b> value.
     */
    var addAlert = function(type, reason, data) {

        var alert = { type: type, data: data, reason: reason, closeable: true };

        for (var i = 0; i < $scope.alerts.length; i++) {
            if (angular.equals($scope.alerts[i], alert)) {
                // let's not show the same alert at one time
                return;
            }
        }
        if(alert.data && alert.data.code && !alert.data.code.startsWith("404")){
            $scope.alerts.push(alert);
        }
    };

    $scope.closeAlert = function(index) {
        $scope.alerts.splice(index, 1);
    };

    $rootScope.$on('$stateChangeSuccess', function(e) {
        $scope.alerts = [];
    });


    /**
     * Expected elements inside data object:
     *    code String: main error code
     *    type String: "success" | "info" | "warning" | "danger"
     *    message String: any message
     *    suggest_refresh Boolean: if true, a message with links to refresh or login again will be added
     */
    $rootScope.$on("genericAlert", function(e, data) {
        var UNKNOWN_ERROR_ACTION = ERROR_CODES.lookupPrettyLabel(ERROR_CODES.UNKNOWN_ERROR);
        var alertType = data.type || "warning";
        var eventAction;

        if (data.code) {
            eventAction = ERROR_CODES.lookupPrettyLabel(data.code) || UNKNOWN_ERROR_ACTION;

            var customer = $authentication.getCustomer();
            if (customer && customer.district_id) {
                data.code += "-d" + customer.district_id;
            }
            if (customer && customer.id) {
                data.code += "-c" + customer.id;
            }

        } else {
            data.code = ERROR_CODES.UNKNOWN_ERROR;
            eventAction = UNKNOWN_ERROR_ACTION;
        }

        data.code = appendErrorLocator(data.code, data);

        data.message = data.message || "An unexpected error occurred.";

        addAlert(alertType, "generic-alert", data);
        $analytics.eventTrack(eventAction, {category: 'Error Alert', label: data.code} );
    });

    /**
     * Expected elements inside rejection object:
     *    object_type = "student" | "classroom" | "teacher" | "school" | "district" | "grade"
     *    object_id = <int>
     */
    $rootScope.$on("editModeBlocked", function(e, rejection) {
        var mainCode = ERROR_CODES.EDIT_MODE_BLOCKED;
        var objectType = "item";
        var objectTypeCode = "NA";
        var objectIdCode = "NA";

        rejection = rejection || {};

        var index = ["student", "classroom", "teacher", "school", "district", "grade"].indexOf(rejection.object_type);
        if (index !== -1) {
            objectType = ( rejection.object_type === "teacher" ? "educator" : rejection.object_type );
            objectTypeCode = index;
        }

        if (rejection.object_id) {
            objectIdCode = "o" + rejection.object_id;
        }

        var errorCode = [mainCode, objectTypeCode, objectIdCode].join("-");
        var productUrl = $rootScope.productApiUrl + "/subscriptions/manage_classroom/";

        addAlert("warning", "edit-mode-blocked", {code: errorCode, object_type: objectType, product_url: productUrl});
        $analytics.eventTrack('Edit Mode Blocked', {category: 'Error Alert', label: errorCode} );
    });

    $rootScope.$on("requestRejected", function(e, rejection) {
        var errorCode = _createRejectionErrorCode(rejection);

        addAlert("warning", "request-rejection", {code: errorCode});
        $analytics.eventTrack('Request Rejected', {category: 'Error Alert', label: errorCode} );
    });

    $rootScope.$on("assignmentNotValid", function(e, rejection) {
        var errorCode = _createRejectionErrorCode(rejection);

        addAlert("warning", "assignment-not-valid", {code: errorCode});
        $analytics.eventTrack('Assignment Not Valid', {category: 'Error Alert', label: errorCode} );
    });

    $rootScope.$on("requestError", function(e, error) {
      var errorCode = error.code;
      var message = error.message;

      addAlert("warning", "request-error", {code: errorCode, message: message});
      $analytics.eventTrack('Request Error', {category: 'Error Alert', label: errorCode} );
    });

    var makeCodedMethodString = function(method) {
        var result = "" + (["GET","POST","PUT","DELETE"]).indexOf(method);

        if (result === "-1") {
            result = "U";
        }

        return result;
    };

    var makeCodedResourceString = function(url) {
        var result = "NA";

        if (url) {
            switch (url.substr(0,3)) {
                case "/n/":
                case "/m/":
                case "/r/":
                case "/e/":
                    result = url.substr(1,1);
                    break;
                default:
                    result = "U";
            }
        }

        return result;
    };

    // append an error locator, with which you can search the server log files for the exception details.
    var appendErrorLocator = function(errorCode, data) {
       return (data && data.apiError) ? (errorCode + "-" + data.apiError.errorLocator) : errorCode;
    };

    function _createRejectionErrorCode(rejection) {
        var errorCode = "-1";
        if (rejection) {
            var errorStatus = "NA", errorMethod = "NA", errorResource = "NA";
            if (rejection.status !== undefined) {
                errorStatus = "" + rejection.status;
            }
            var config = rejection.config;
            if (config && config.method) {
                errorMethod = makeCodedMethodString(config.method);
            }
            if (config && config.url) {
                errorResource = makeCodedResourceString(config.url);
            }
            errorCode = [errorStatus, errorMethod, errorResource].join("-");
        }

        var customer = $authentication.getCustomer();
        if (customer && customer.district_id) {
            errorCode += "-d" + customer.district_id;
        }
        if (customer && customer.id) {
            errorCode += "-c" + customer.id;
        }

        return appendErrorLocator(errorCode, rejection.data);
    }
}]);
